"use client";

import TextSubHeader from "@/components/typography/TextSubHeader";
import TextHeader from "@/components/typography/TextHeader";

export default function LocationDescription() {
  return (
    <div className="pb-16 pt-12 lg:pb-24 lg:pt-24">
      <div className="m-auto max-w-screen-sm px-5">
        <TextSubHeader>Lokalizacja</TextSubHeader>
        <TextHeader>
          Zainwestuj w apartament w Szczyrku 100 m od stoku!
        </TextHeader>
      </div>
    </div>
  );
}
